export default __webpack_public_path__ + "static/media/frequency.0f851b4c.svg";